import * as angular from "angular";
import {IController} from "angular";

export class bringozTimeZoneDisplayCtrl implements IController {

  notBefore: any;
  notAfter: any;
  timeZoneId: string;
  configZoneId: string;
  isShowTime: boolean;
  isColumn: boolean;
  isSmall: boolean;
  isIgnoreOffsetDiff: boolean;

  private timeZoneOffsetDiff: number;

  /* @ngInject */
  constructor(private splitService, private moment) {

  }

  $onInit() {
    this.checkTimeZoneOffsetDiff();
  }

  $onChanges(changes) {
    if (changes.notBefore && !changes.notBefore.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }

    if (changes.notAfter && !changes.notAfter.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }

    if (changes.configZoneId && !changes.configZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }

    if (changes.timeZoneId && !changes.timeZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }
  }

  checkTimeZoneOffsetDiff() {
    const date = this.moment();

    this.timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(this.timeZoneId, this.notBefore || date);
  }
}
angular
  .module('bringoz.admin.commons')
  .component('bringozTimeZoneDisplay', {
    bindings: {
      notBefore: '<?',
      notAfter: '<?',
      timeZoneId: '<',
      configZoneId: '<',
      isShowTime: '<?',
      isColumn: '<?',
      isSmall: '<?',
      isIgnoreOffsetDiff: '<?'
    },
    template: require('./bringoz-time-zone-display.html').default,
    controller: bringozTimeZoneDisplayCtrl
  });
